import React, { useState } from "react";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import { authenticateUser, setAuthenticated } from "../utils/authUtils";
import "./LoginScreen.css";

const LoginScreen = ({ onLogin }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const logLoginAttempt = async () => {
    // Get fingerprint
    const fpPromise = FingerprintJS.load();
    const fp = await fpPromise;
    const result = await fp.get();
    const fingerprint = result.visitorId;
    // Get date/time
    const now = new Date();
    const dateStr = now
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "2-digit",
      })
      .replace(/ /g, "/");

    // Format time in 12-hour format with AM/PM
    const hours = now.getHours();
    const minutes = now.getMinutes().toString().padStart(2, "0");
    const seconds = now.getSeconds().toString().padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    const hours12 = hours % 12 || 12; // Convert 0 to 12 for 12 AM
    const timeStr = `${hours12.toString().padStart(2, "0")}:${minutes}:${seconds}${ampm}`;

    // Get user-agent
    const userAgent = navigator.userAgent;
    // Compose log entry
    const entry = `${dateStr} ${timeStr} | Fingerprint: ${fingerprint} | UA: ${userAgent}`;
    // Save to localStorage
    let log = localStorage.getItem("loginLog") || "";

    // If the log already has content and doesn't end with double newline,
    // add proper line spacing for readability
    if (log && !log.endsWith("\n\n") && !log.endsWith("\n")) {
      log += "\n\n";
    } else if (log && log.endsWith("\n") && !log.endsWith("\n\n")) {
      log += "\n";
    }

    log += entry;
    localStorage.setItem("loginLog", log);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    try {
      const result = await authenticateUser(username, password);
      if (result.success) {
        setAuthenticated(true);
        localStorage.setItem("username", result.user.username);
        await logLoginAttempt();
        onLogin(result.user);
      } else {
        setError(result.error);
      }
    } catch (error) {
      setError("An error occurred during login");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="developer-credit">Designed and Developed by BYTARION LTD.</div>
        <h1 className="app-name">Resource Allocation Manager</h1>
        <h2 className="login-title">Login Required</h2>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="input-group">
            <input
              type="text"
              placeholder="admin"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="login-input"
              required
            />
          </div>

          <div className="input-group">
            <input
              type="password"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="login-input"
              required
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          <button type="submit" className="login-button" disabled={isLoading}>
            {isLoading ? "Logging in..." : "Login"}
          </button>
        </form>

        <div className="copyright-text">
          © {new Date().getFullYear()} BYTARION LTD. All rights reserved.
        </div>
      </div>
    </div>
  );
};

export default LoginScreen;
